import { fetchConversation } from '@app/api'
import {
  getConversationById,
  getMessages,
  initialConversationItem,
} from '@app/helpers'

import { UnknownThreadEventCapturedPayload } from '@app/hooks'
import { handleForbiddenConversationError } from '@app/utils'

import { logger } from '@lib/utils'

import type { ThreadParticipantsAddedEvent } from '../types'
import type { CreateOnChatParticipantsAddedParams } from './types'

export const createOnChatParticipantsAdded = ({
  dispatch,
  refState,
  getDependencies,
  getReceivedUnreadStatus,
  onConversationForbidden,
}: CreateOnChatParticipantsAddedParams) => {
  return async (event: ThreadParticipantsAddedEvent) => {
    logger('onChatParticipantsAdded', event.participantsAdded, '#c203fc')

    if (
      refState.current.acsChatParticipantId ===
      event.participantsAdded[0]?.id?.communicationUserId
    ) {
      return
    }

    const conversation = getConversationById(
      refState.current.conversations,
      event.threadId
    )

    if (!conversation) {
      return
    }

    let updatedConversation: Awaited<ReturnType<typeof fetchConversation>>
    try {
      updatedConversation = await fetchConversation(event.threadId)
    } catch (error) {
      if (handleForbiddenConversationError(error, onConversationForbidden)) {
        return
      }

      throw error
    }

    const { listings, accounts } = await getDependencies([updatedConversation])

    const messages = getMessages(
      updatedConversation.lastMessage,
      conversation.messages
    )

    const payload: UnknownThreadEventCapturedPayload = {
      listings,
      accounts,
      conversation: {
        ...initialConversationItem,
        ...updatedConversation,
        messages,
        total: 0,
        unread: getReceivedUnreadStatus(
          updatedConversation.id,
          updatedConversation.participants
        ),
      },
    }

    dispatch({
      type: 'UNKNOWN_THREAD_EVENT_CAPTURED',
      payload,
    })
  }
}
